import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import InputsFromMaintenance41_2aTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const InputsFromMaintenance41_2a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("INPUTS_FROM_MAINTENANCE") || "Inputs from maintenance"}
        subDescription={t("INPUTS_FROM_MAINTENANCE_41_2A_DESC") || "Fill in information about inputs from maintenance processes."}
        isNormal={true}
        number={"41.2a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`inputs-from-maintenance-41-2a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <InputsFromMaintenance41_2aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default InputsFromMaintenance41_2a;

